import { useQuery } from "react-query";
import {
    GetListShiftResponse,
    ParamsGetListShift,
} from "../../constants/types";
import axios from "../axios";

const queryString = require("query-string");

const handleRequest = async (params: ParamsGetListShift) => {
    const apiGetListShift = queryString.stringifyUrl({
        url: "/api/shift-get",
        query: {
            ukmId: params.ukmId,
            page: params.page,
            size: params.size,
            tglAwal: params.tglAwal,
            tglAkhir: params.tglAkhir,
        },
    });
    const { data } = await axios.get<GetListShiftResponse>(apiGetListShift);
    return data.data;
};

export default function useListShift(params: ParamsGetListShift) {
    return useQuery<GetListShiftResponse["data"]>(
        ["list-shift", params],
        () => handleRequest(params),
    );
}
